import React, { useEffect, useRef, useState } from 'react';

import { NO_FILTER, EMPTY_TEXT, FILTER_KEYS, ENTITY_VALUES } from '../../config/constants';
import Table, { RowsType } from '../Shared/CustomTable';
import Loader from '../Shared/Loader';
import BasicDropdown from '../Shared/BasicDropdown/BasicDropdown';
import { useFiltersState } from '../../store/hooks';
import { useRouter } from '../../helpers/customHooks';
import { useHealthDispatch, useHealthState } from '../../store/hooks/health';
import { FiltersHealthEntityTab, TypeValue } from './types';

export default () => {

  const { specificScope }  = useRouter();
  const { [FILTER_KEYS.VENUE]: venue,
    [FILTER_KEYS.TIME_SLIDER]: timeSlider
  } = useFiltersState(specificScope, FILTER_KEYS.VENUE, FILTER_KEYS.TIME_SLIDER);
  const { entityData } = useHealthState();
  const { getEntityData, changeMessageNoDaGeneric: noData} = useHealthDispatch();
  const second = useRef(false);
  useEffect(() => {
    if (venue && venue.value && venue.value.siteId) {
      getEntityData(venue.value.siteId, true);
      second.current = true;
    } else {
      noData();
    }
  }, [venue]);
  useEffect(() => {
    if (second.current) {
      if (venue && venue.value && venue.value.siteId && timeSlider) {
        getEntityData(venue.value.siteId, !timeSlider.interval);
      } else {
        noData();
      }
    }
  }, [timeSlider]);
  const [filters, setFilters] = useState<FiltersHealthEntityTab>({ type: NO_FILTER, entity: '', tagId: '', location: NO_FILTER });
  const [typeValues, setTypeValues] = useState<TypeValue[]>([]);
  const [locationValues, setLocationValues] = useState<TypeValue[]>([]);
  useEffect(() => {
    const validTypes = new Set<string>();
    const validLocations = new Set<string>();
    entityData.forEach((data) => {
      validTypes.add(data.type);
      validLocations.add(data.location);
    });
    setTypeValues([
      { name: NO_FILTER, value: NO_FILTER },
      ...Array.from(validTypes).map((type) => (type === EMPTY_TEXT ? { name: 'EMPTY', value: EMPTY_TEXT } : {
        name: type,
        value: type
      }))
    ]);
    setLocationValues([
      { name: NO_FILTER, value: NO_FILTER },
      ...Array.from(validLocations).map(type => (type === EMPTY_TEXT ? {
        name: 'EMPTY',
        value: EMPTY_TEXT
      } : { name: type, value: type }))
    ]);
  }, [entityData]);
  const headers = [
    {
      style: { width: '94px', paddingLeft: '20px' },
      isOrderly: true,
      leftSortIcon: '25px',
      print: () => (
        <>
          Type
          <div onClick={event => event.stopPropagation()} style={{ width: '63px' }}>
            <BasicDropdown
              type={{
                name: 'table-header-type',
                types: typeValues,
                title: 'TYPE'
              }}
              selectedType={typeValues.find((type) => type.value === (filters && filters.type))}
              onSelectType={(itemsSelected:TypeValue) => setFilters((prevState:FiltersHealthEntityTab) => ({ ...prevState, type: itemsSelected.value }))}
            />
          </div>
        </>
      )
    },
    {
      style: { width: '145px' },
      isOrderly: true,
      leftSortIcon: '17px',
      print: () => (
        <>
          Entity
          <input
            className="table-header-input"
            type="text"
            placeholder="Search"
            value={filters.entity}
            onClick={e => e.stopPropagation()}
            onChange={({ target }) => setFilters(prevState => ({ ...prevState, entity: target.value }))}
          />
        </>
      )
    },
    { content: 'Tag Position', style: { width: '123px', verticalAlign: 'top' }, isOrderly: true, leftSortIcon: '36px' },
    {
      style: { width: '91px', verticalAlign: 'top' },
      isOrderly: true,
      print: () => (
        <>
          Tag Id
          <input
            className="table-header-input"
            type="text"
            placeholder="Search"
            value={filters.tagId}
            onClick={e => e.stopPropagation()}
            onChange={({ target }) => setFilters(prevState => ({ ...prevState, tagId: target.value }))}
          />
        </>
      )
    },
    { content: 'X', style: { width: '80px', verticalAlign: 'top' }, isOrderly: true, leftSortIcon: '3px' },
    { content: 'Y', style: { width: '80px', verticalAlign: 'top' }, isOrderly: true, leftSortIcon: '3px' },
    { content: 'Age (sec)', style: { width: '75px', verticalAlign: 'top' }, isOrderly: true, leftSortIcon: '10px' },
    { content: 'T Count', style: { width: '77px', verticalAlign: 'top' }, isOrderly: true, leftSortIcon: '23px' },
    { content: 'T Rate (5 min)', style: { width: '94px', verticalAlign: 'top' }, isOrderly: true },
    { content: 'T Rate (1 min)', style: { width: '101px', verticalAlign: 'top' }, isOrderly: true },
    { content: 'Pending Whereport Off', style: { width: '78px', verticalAlign: 'top' }, isOrderly: true },
    {
      style: { width: '134px' },
      isOrderly: true,
      leftSortIcon: '25px',
      print: () => (
        <>
          Location
          <div onClick={event => event.stopPropagation()} style={{ width: '116px' }}>
            <BasicDropdown
              type={{
                name: 'table-header-location',
                types: locationValues,
                title: 'LOCATION'
              }}
              selectedType={locationValues.find(type => type.value === (filters && filters.location))}
              onSelectType={(itemsSelected:TypeValue) => setFilters(prevState => ({
                ...prevState,
                location: itemsSelected.value
              }))}
            />
          </div>
        </>
      )
    },
    { content: 'Battery State', style: { width: '100px', verticalAlign: 'top' }, isOrderly: true }
  ];
  const rows: RowsType<string, number, string[]> = [];

  const players = new Set(), balls = new Set();
  let unknown = 0;
  entityData.filter((data) => {
    const regexEntity = new RegExp(filters.entity.trim(), 'i');
    const regexTagId = new RegExp(filters.tagId.trim(), 'i');
    return (filters.entity.trim() === '' || regexEntity.test(data.entity)) &&
      (filters.tagId.trim() === '' || regexTagId.test(data.id)) &&
      (filters.type === NO_FILTER || data.type === filters.type) &&
      (filters.location === NO_FILTER || data.location === filters.location);
  }).forEach((data) => {
    if (ENTITY_VALUES.PLAYER === data.type) {
      players.add(data.type + data.entity_id);
    } else if (ENTITY_VALUES.BALL === data.type) {
      balls.add(data.type + data.entity_id);
    } else if ('Unknown' === data.type) {
      unknown++;
    }
    rows.push({
      columns: [
        { content: data.type, style: { paddingLeft: '20px' } },
        {
          content: data.entity.split(' '),
          order: (entityA:string[], entityB:string[]) => {
            for (let i = 0; i < entityA.length && i < entityB.length; i++) {
              if (entityA[i] !== entityB[i]) {
                if (isNaN(+entityA[i]) || isNaN(+entityB[i])) {
                  return entityA[i].localeCompare(entityB[i]);
                }
                return +entityA[i] - +entityB[i];
              }
            }
            return entityA.length - entityB.length;
          },
          print: ((content:string[]) => content.join(' '))
        },
        { content: data.tagPosition },
        { content: data.id },
        { content: data.X },
        { content: data.Y },
        { content: data.last_time },
        { content: data.count },
        { content: data.five_minute_locate_rate,
        order: (contentA:number, contentB:number) => contentA - contentB },
        { content: data.one_minute_locate_rate,
          order: (contentA:number, contentB:number) => contentA - contentB },
        {
          content: data.pend_whr_port_off,
          print: (content:string) => content ? <i className="mdi mdi-check" style={{ color: 'green' }} /> :
            <i className="mdi mdi-close" style={{ color: 'red' }} />,
            order: (contentA: string,  contentB: string) => {
              if (!Number.isNaN(+contentA) && !Number.isNaN(+contentB)) {
                return +contentA - +contentB;
              } else if (!Number.isNaN(+contentA)) {
                return -1;
              } else if (!Number.isNaN(+contentB)) {
                return 1;
              }
              return 0;
            }
        },
        { content: data.location },
        {
          content: data.battery_state,
          print: (content:string) => content === 'Good' ? <i className="mdi mdi-battery" style={{ color: 'green' }} /> :
            <i className="mdi mdi-battery-10" style={{ color: 'red' }} />
        }
      ],
      id: data.id + data.event
    });
  });
  return (
    <Loader style={{ height: 'calc(100vh - 239px)', border: '2px solid rgba(219, 225, 229, 0.6)' }}>
      <div style={{ fontSize: '14px', padding: '10px 20px', display: 'flex' }}>
        <div style={{ flex: '1' }}>Players:{players.size} | Balls:{balls.size} | Unknown:{unknown}</div>
        <div>{entityData.length} Result(s)</div>
      </div>
      <div style={{ height: 'calc(100% - 41px)' }}>
        <Table
          headers={headers}
          rows={rows}
          default={{ orderColumn: -2 }}
        />
      </div>
    </Loader>
  );
};
